<template>
    <div>

        <config-main-title>
            Fila de Leads
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Fila
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma fila identificada.'" 
                icon="fas fa-search"
                :action="'Incluir Fila'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="acessos(dado)" v-else>
                            <i class="fas fa-user-lock mr-2"></i>
                            {{ dado.acessos.length }}
                        </button>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_fila_lead ? '' : 'Nova' }}
                            Fila
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_fila_lead">
                                #{{ item.id_fila_lead }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    placeholder="Informe o título da fila..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Tipo"
                                    type="select"
                                    :optionsList="lista_models_leads"
                                    optionsData="id"
                                    :edicao="!item.id_fila_lead"
                                    :validate="validate"
                                    required
                                    v-model="item.model_type" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div class="row mt-3" v-if="item.model_type == 'App\\azure\\requisicao' || item.model_type == 'App\\azure\\receita'">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Comunicar ao incluir"
                                    :validate="validate"
                                    v-model="item.fl_comunicar" />
                            </div>
                        </div>

                        <div class="row mt-1" v-if="( item.model_type == 'App\\azure\\requisicao' || item.model_type == 'App\\azure\\receita' ) && item.filtros && item.filtros.length">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Filtrar itens a partir dos filtros definidos"
                                    :validate="validate"
                                    v-model="item.fl_filtro_items" />
                            </div>
                        </div>

                        <div class="alert alert-info small py-2" v-if="item.fl_filtro_items">
                                Ao marcar essa opção, os filtros serão usados para identificar a {{ item.model_type == 'App\\azure\\requisicao' ? 'requisição' : 'receita' }}, como também para filtrar os itens presentes.
                            </div>

                        <div class="row" v-if="item.model_type == 'App\\azure\\atendimentoProcedimento'">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Tempo de Retorno Padrão"
                                    required
                                    :validate="validate"
                                    v-model="item.in_tempo_retorno">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">dias</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <template v-if="item.fl_comunicar">

                            <!-- Comunicar Para -->
                            <az-sub-title title="Comunicar Para">
                                <a href="#" @click.prevent="incluir_destino()">
                                    <i class="fas fa-plus mr-2"></i>
                                    Incluir
                                </a>
                            </az-sub-title>
                            <div v-if="!item.js_comunicacao.length">
                                Nenhum destino definido.
                            </div>
                            <div v-else>
                                <div class="form-row" v-for="(destino, idx) in item.js_comunicacao" :key="idx">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="[
                                                { id: 'E', search: 'e-mail' },
                                                { id: 'T', search: 'Telegram' },
                                            ]"
                                            optionsData="id"
                                            :validate="validate"
                                            required
                                            v-model="destino.tipo" />
                                    </div>
                                    <div class="col col-12 col-md-5">
                                        <az-input
                                            sizing="sm"
                                            :type="destino.tipo == 'E' ? 'email' : 'number'"
                                            v-if="destino.tipo"
                                            :placeholder="destino.tipo == 'E' ? 'e-mail' : 'Id do Telegram'"
                                            :validate="validate"
                                            required
                                            v-model="destino.conta">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend input-group-sm">
                                                    <button class="btn btn-outline-danger btn-sm" type="button" id="button-addon1" @click="remove_destino(item, idx)">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Nome..."
                                            :validate="validate"
                                            v-model="destino.nome" />
                                    </div>
                                </div>
                            </div>

                        </template>

                        <template v-if="flKualizCrm && item.js_kualiz_params">

                            <az-sub-title title="Kualiz / CRM / Integração" class="mt-3" />

                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Funil"
                                        placeholder="Id do funil..."
                                        v-model="item.js_kualiz_params.fk_pipeline" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Etapa"
                                        placeholder="Id da etapa..."
                                        v-model="item.js_kualiz_params.fk_stage" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Responsável"
                                        placeholder="Id do responsável..."
                                        v-model="item.js_kualiz_params.responsable_id" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Origem"
                                        placeholder="Id da origem..."
                                        v-model="item.js_kualiz_params.origin" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Etiqueta"
                                        placeholder="Id da etiqueta..."
                                        v-model="item.js_kualiz_params.tag_id" />
                                </div>
                            </div>
                        </template>

                        <!-- Filtros -->
                        <filtro-model class="mt-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="filaLead" :id="item.id_fila_lead" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_fila_lead ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
            fila_proced: false,
            flKualizCrm: false 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel,
        AzSubTitle, 
        EdicaoAcessos,
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\procedimentoGrupo', search:'Grupo do Procedimento', service: 'procedimento_grupos.index'}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'},
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }

            if ( this.item && this.item.model_type == 'App\\azure\\receita' ) { 
                opcoes.push({id:'App\\azure\\medicamento', search:'Medicamento',service:'medicamentos.index', parms: { pep: true }});
                opcoes.push({id:'tag-medicamento', search:'Classificação do Medicamento', service: 'medicamentos.index', parms: { pep: true }, tag: true});
            }

            if ( this.item && this.item.model_type == 'cancelados' ) { 
                opcoes.push({id:'App\\azure\\motivo', search:'Motivo de Cancelamento',service:'motivos.index', parms: { tipo: 'atp'}});
            }
            
            return _.orderBy(opcoes, 'search');
        },

        lista_models_leads: function () { 
            return [
                { id: 'App\\azure\\atendimento', search: 'Atendidos' },
                { id: 'App\\azure\\cuidadoPaciente', search: 'Cuidado Coordenado' },
                { id: 'App\\azure\\marcacao', search: 'Faltosos' },
                { id: 'cancelados', search: 'Marcações/Atendimentos Cancelados' },
                { id: 'App\\azure\\orcamento', search: 'Orçamentos' },
                { id: 'App\\azure\\receita', search: 'Receita' },
                { id: 'App\\azure\\requisicao', search: 'Requisição' },
                { id: 'App\\azure\\atendimentoProcedimento', search: 'Retorno Previsto' },
                { id: 'App\\azure\\retornoAtendimento', search: 'Retorno Programado' },
            ];
        }
    },

    methods: { 
        remove_destino(item, idx) { 
            item.js_comunicacao.splice(idx,1);
        },

        incluir_destino() { 
            this.item.js_comunicacao.push({
                tipo: 'E',
                conta: "", 
            });
        },

        remover_destino(idx) { 
            this.item.js_comunicacao.splice(idx,1);
        },

        acessos(item) { 
          this.$refs.acessos.abrir('App\\azure\\filaLead', item.id_fila_lead);
        },
        remover_status (index) { 
            this.item.lista_status.splice(index,1);
        },

        add_status () { 
            if ( !this.status_para_incluir )
                return;

            if ( this.item.lista_status.findIndex(item => item.id_status_laudo == this.status_para_incluir.id_status_laudo) < 0 ) { 
                this.item.lista_status.push(this.status_para_incluir);
            }

            this.$nextTick(() => { 
                this.status_para_incluir = "";
            });
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },
        incluir_filtro(item) { 
            item.filtros.push({ 
                id_fila_lead_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },
        incluir () { 
            this.validate = false;

            let item = {
                st_titulo: "", 
                fl_ativo: true,
                st_observacoes: "", 
                js_comunicacao: [],
                filtros: [],
                fl_comunicar: false, 
                model_type: 'App\\azure\\requisicao',
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'fila_leads',
                func: 'index',
                parms: { 
                    fila_procedimento: this.fila_proced,
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            if ( !this.item.endereco ) { 
                this.item.endereco = { cidade: {} };
            }

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'fila_leads',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'fila_leads',
                dados: item,
            });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    beforeMount() { 
        if ( this.$route.name == 'c-fila-proced' ) { 
            this.fila_proced = true;
        }
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Fila de Leads", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        let query = {
        q: [
          {
            name: "configuracoes.check",
            id: "kualiz_crm",
            parms:  {
              st_slug: "integracao-crm-kualiz",
              st_valor: "1",
            }
          }
          
        ]
      }

        this.axios.post('/aql', query)
            .then(res => {
          
                if(res.data.kualiz_crm.status == 200) {
                    this.flKualizCrm = res.data.kualiz_crm.data
                }

            }
        );

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>